import { useMutation } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { PostulantForm } from '../components/postulant-form';
import { getPostulant } from '../services/api';
import useStore from '../store/useStore';
import { mapPostulantEdit } from '../utils/postulant';

export const PostulantEdit = observer(({ cloudflareRecaptcha }) => {
  const [postulant, setPostulant] = useState({});
  const { getDataPostulant } = useStore();
  const { hr } = getDataPostulant;

  const _getPostulant = useMutation(getPostulant, {
    onSuccess: (data) => setPostulant(mapPostulantEdit(data.data.response))
  });

  useEffect(() => {
    if (hr)
      _getPostulant.mutate({
        apply_with: 3,
        source: 'hr',
        postulantId: hr
      });
  }, [hr]);

  return (
    <PostulantForm
      postulant={postulant}
      action='edit'
      loading={_getPostulant.isLoading}
      setPostulant={setPostulant}
      cloudflareRecaptcha={cloudflareRecaptcha}
    />
  );
});
